import dynamic from 'next/dynamic';
import {useDispatch} from 'react-redux';

import {useIsLargeDevice, useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';

import {NavLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, DOWNLOADAPP} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {Box} from '@mui/material';
import {wrapper} from '@jobseeker/common-core/stores';
import {useEffect} from 'react';
import {getCdnUrl, TrackEventUBA} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';

const DynamicDownloadApp = dynamic(
  () => import('@components/Home/DownloadApp')
);

type DownloadAppProps = {
  seoConfig: object;
};

const DownloadApp = ({seoConfig}: DownloadAppProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, 'downloadapp');

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const {
    section: {downloadApp},
  }: /* eslint-disable @typescript-eslint/no-explicit-any */ any =
    metaData[HOME] || {};

  const theme = useWrappedTheme();
  const isLargeXl = useIsLargeDevice('xl');
  const isAboveMobile = useIsLargeDevice('sm');

  const router = useRouter();
  useEffect(() => {
    TrackEventUBA('dowloadAppPageView', 'view', {
      ref: router.query.ref || '',
      pageName: 'Download App Page',
      sessionUsername: `${sessionStorage.getItem('userId')}`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <Box px={{md: 15}}>
          <DynamicDownloadApp
            appImage={downloadApp['appImage']}
            downloadText={downloadApp['downloadText']}
            dotSvg={`url(${downloadApp['dotSvg']}) left center/7px no-repeat`}
            isLargeXl={isLargeXl}
            isAboveMobile={isAboveMobile}
            heading={downloadApp['heading']}
            backgroundImg={{
              large: `url(${getCdnUrl(
                downloadApp.backgroundImg.large
              )}) center bottom/100% no-repeat`,
              small: `url(${getCdnUrl(
                downloadApp.backgroundImg.small
              )}) center bottom/100% no-repeat`,
            }}
            downloadAppContent={downloadApp['downloadAppContent']}
            downloadAppButton={downloadApp['downloadAppButton']}
            downloadAppQr={downloadApp['downloadAppQr']}
            theme={theme}
          />
        </Box>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async () => {
    const seoConfig = await loadSEO('downloadApp');

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: DOWNLOADAPP},
    });

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default DownloadApp;
